import { useParams, useNavigate } from "react-router-dom";
import { getUserBook } from "../apiUserBook";
import { useQuery } from "@tanstack/react-query";
import { createFetchErrorMessage } from "utils/api/Api";
import { UserBookInfo } from "../common/UserBookInfo";
import { toast } from 'react-toastify';
import ErrorMessageBox from "app/components/ErrorMessageBox";
import { UserBookEpisodeForm } from "./UserBookEpisodeForm";

export const UserBookEpisodeCreate = () => {
    const navigate = useNavigate();
    const { school, book } = useParams();

    const { data: userBook, isLoading, isError, error } = useQuery({
        queryKey: ['userbook', book],
        queryFn: getUserBook,
        refetchOnMount: false,
    });

    if (isLoading) return null;
    if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;
    if (userBook.data === '') {
        toast.error('작품 정보가 없습니다.');
        navigate(`/${school}/userbook`);
    }

    const initialData = { subject: `${userBook.data?.subject} ${userBook.data?.episodeCount + 1}화 `, content: '', id: null };
    return (
        <div className="userBookEpisodeForm">
            <UserBookInfo bookId={book} />
            <UserBookEpisodeForm initialData={initialData} />
        </div>
    );
};